































































































































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { Getter } from 'vuex-class';
import { PARKING_LOT_DETAIL, PARKING_LOT_CREATE, PARKING_LOT_EDIT } from '../router-names';
import moment from 'moment';
import * as _ from 'lodash';
import Utils from '@root/utils/common';
import FileImportMixin from '@root/common/mixins/import/import.tsx';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import {
  queryParkingLotList,
  exportParkingLotList,
  getRegion,
  changeStatus,
  baseDeviceTemplate,
  baseDeviceExport,
  downloadexport,
  getParkQRCode
} from '@/api/parking-lot-management/index';
import {
  dictParkTypeMap,
  dictTimeCompareMap,
  dictoperationStateMap,
  dictConnectStatusMap,
  DictoperationState
} from '@/types/parking-lot-management/dictionaries';
import QRCode from 'qrcodejs2';
import { API_SERVER } from '@root/common/config';
import { isShiDaill } from '@root/utils/env';

@Component({
  name: 'ParkingLotList',
  components: { ParkingLotSearch }
})
// @Component
export default class ParkingLotList extends Mixins(TableMixin, TableWidthMixin, FileImportMixin) {
  //判断是否是时代邻里
  isshidaill: boolean = isShiDaill;

  isWenLv: boolean = 'wenlv,wenlvtest'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV); //查看图片文旅定制化

  parkId = ''; // 车场ID,多个车场ID逗号分隔
  parkIds = [];
  parkName = ''; //车场名称
  // park = []
  areaArr = []; //区域位置
  status = [];
  statusOperate = ''; //运营状态绑定 用于切换运营状态
  connectStatus = [];
  parkType = '';
  tableLoading = false;
  isstatusOperate = false;
  tableData: any[] = []; // 表数据
  getRegionList: any[] = []; //省市区下拉框
  deviceProvider = ''; //边缘侧服务供应商
  plateNumOrderBy = '';

  // 合计数据
  private sumRowData: any = {};

  @Getter('dictionaries/parkType')
  parkTypeMap?: any;
  get parkTypeOptions(): any[] {
    return Utils.toLabelVal(this.parkTypeMap);
  }

  @Getter('dictionaries/parkDeviceProvider')
  parkDeviceProviderMap?: object;
  get edgeServiceProvider(): any[] {
    return Utils.toLabelVal(this.parkDeviceProviderMap);
  }

  dictoperationStateMap = dictoperationStateMap;
  operationStateOptions: IOption[] = Utils.toLabelVal(dictoperationStateMap);
  DictoperationState = DictoperationState;
  // 在线状态
  connectStatusOptions: IOption[] = Utils.toLabelVal(dictConnectStatusMap);

  get formFields() {
    if (this.isshidaill) {
      return [
        {
          prop: 'parkName',
          label: '车场名称'
        },
        {
          prop: 'parkCode',
          label: '车场code'
        }
      ];
    }
    return [
      {
        prop: 'parkName',
        label: '车场名称'
      },
      {
        prop: 'parkCode',
        label: '车场code'
      },
      {
        prop: 'payPlateCode',
        label: '预缴费url'
      }
    ];
  }

  formData = {
    parkName: '',
    parkCode: '',
    payPlateCode: ''
  };
  previewVisible: boolean = false;
  qrCodeLoading: boolean = false;

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 210,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '所属机构',
        dataIndex: 'organName',
        width: 210,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '连接状态',
        dataIndex: 'connectStatus',
        width: 80,
        scopedSlots: { customRender: 'connectStatus' }
      },
      {
        title: '所属地区',
        dataIndex: 'location',
        width: 210,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '边缘侧服务商',
        dataIndex: 'deviceProvider',
        width: 210,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '边缘测版本号',
        dataIndex: 'misVersion',
        width: 210,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '区域数量',
        dataIndex: 'areaNum',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '通道数量',
        dataIndex: 'channelNum',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '车位总数',
        dataIndex: 'plateNum',
        width: 140,
        sortable: true,
        customRender: (text: any) => text || '--'
      },
      {
        title: '产权车位数',
        dataIndex: 'propertyNum',
        width: 120,
        customRender: (text: any) => text || '--'
      },

      {
        title: '长租车位数',
        dataIndex: 'monthNum',
        width: 120,
        customRender: (text: any) => text || '--'
      },

      {
        title: '临停车位数',
        dataIndex: 'tempNum',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '车场业态',
        dataIndex: 'parkType',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '空闲车位数',
        dataIndex: 'freeNum',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '在场车辆',
        dataIndex: 'enterCarNum',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '运营状态',
        dataIndex: 'status',
        width: 100,
        scopedSlots: { customRender: 'status' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 240,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  // 显示运营状态弹框
  showStatusOperate(row) {
    this.isstatusOperate = true;
    this.parkId = row.parkId;
    this.statusOperate = row.status;
  }
  // 运营状态切换
  async changeOperationStatus() {
    try {
      const { status, msg, code, data } = await changeStatus({ parkId: this.parkId, status: this.statusOperate });
      this.$message.success('运营状态切换成功');
      this.parkId = '';
      this.isstatusOperate = false;
      this.fetchTableData(); //重新渲染
      this.statusOperate = ''; //清空状态
    } catch (error) {
      this.$message.error((error && error.msg) || '运营状态切换失败');
    }
  }
  // 运营状态取消
  closeOperationStatus(e: any) {
    this.isstatusOperate = false;
    this.parkId = '';
    this.statusOperate = '';
  }
  activated() {
    console.log(this.$route.query.search, 'ppppppp--->');
    if (this.$route.query.search === 'search') {
      // this.fetchTableData()
    }
  }
  // 生命周期初始化
  created() {
    this.fetchTableData();
    this.setRegionList();
    const str = 'https://iot.zparking-tech.com/h5/business-coupon/login?redirect=%2Fhome';
    //console.log(str.split(':'))
    const arr = str.split(':');
    console.log('http' + arr[1]);
  }

  // 渲染车场列表请求
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const { status, code, msg, data } = await queryParkingLotList({
        parkName: this.parkName,
        parkId: this.parkIds.join(','),
        // areaArr: this.areaArr,
        provinceId: this.areaArr[0],
        cityId: this.areaArr[1],
        areaId: this.areaArr[2],
        status: this.status.join(','),
        connectStatus: this.connectStatus.join(','),
        parkType: this.parkType,
        currPage: this.current,
        pageSize: this.pageSize,
        deviceProvider: this.deviceProvider,
        plateNumOrderBy: this.plateNumOrderBy
      });
      const { datas, totalNum, totalPage, currPage, pageSize, total } = data;

      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
      this.sumRowData = total;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  // 获取省市区
  async setRegionList() {
    try {
      const { status, msg, code, data } = await getRegion({ userId: '11' });
      if (status === '9999') {
        this.getRegionList = data;
      }
    } catch (error) {
      console.log(error);
      // this.$message.error((error && error.msg) || '系统繁忙，请稍后再试')
    }
  }

  // 清空搜索条件
  clear({ defaultParkIdList }) {
    this.parkName = '';
    this.parkIds = defaultParkIdList;
    this.areaArr = [];
    this.status = [];
    this.connectStatus = [];
    this.parkType = '';
    this.parkId = '';
    this.deviceProvider = '';
    this.fetchTableData(true);
  }
  /**
   * 链接跳转
   */
  // 跳转添加
  toCreate() {
    this.$router.push({
      name: PARKING_LOT_CREATE
    });
  }
  // 跳转编辑
  toUpdate(parkId: string) {
    this.$router.push({
      name: PARKING_LOT_EDIT,
      params: {
        parkId
      }
    });
  }
  // 跳转详情
  toDetail(parkId: string) {
    this.$router.push({
      name: PARKING_LOT_DETAIL,
      params: {
        parkId
      }
    });
  }
  downloadLoading = false;
  //下载
  private async downLoadTemplate() {
    try {
      if (this.downloadLoading) return;
      this.downloadLoading = true;
      await baseDeviceTemplate({}, '车场导入模板');
    } catch (e) {
      console.log('下载失败');
    } finally {
      this.downloadLoading = false;
    }
  }

  tableVisiter = false;
  keyword = '';
  downLoadErrMsgLoading = false;
  errMsgdes = '';
  // 导入弹框
  // 失败数据
  successInfo() {
    this.fetchTableData();
    this.tableVisiter = false;
  }
  showTableErr(e) {
    try {
      // console.log(e, 'error---------->')
      this.tableVisiter = true;
      this.keyword = e.data;
      this.errMsgdes = e.msg;
    } catch (e) {
      console.log(e);
    }
  }
  handleCancel() {
    this.tableVisiter = false;
  }
  async downLoadErrMsg() {
    try {
      if (this.downLoadErrMsgLoading) return;
      this.downLoadErrMsgLoading = true;
      const res = await baseDeviceExport({ keyword: this.keyword });
    } catch (e) {
      console.log(e);
    } finally {
      this.downLoadErrMsgLoading = false;
    }
  }
  codeVisible: boolean = false;

  //显示二维码弹框
  async showCode(record) {
    this.codeVisible = true;
    if (this.isshidaill) {
      this.imgParkId = record.parkId;
      this.getQRCodeDetail();
    } else {
      this.formData.parkName = record.parkName || '';
      this.formData.parkCode = record.parkCode || '';
      this.formData.payPlateCode = record.payPlateCode || '';
      this.$nextTick(function() {
        let els = document.querySelector('#qrcode');
        while (els.hasChildNodes()) {
          els.removeChild(els.firstChild);
        }
        //生成二维码
        this.creatQrCode(record.payPlateCode);
      });
    }
  }

  //创建二维码
  creatQrCode(url) {
    var qrcode = new QRCode(this.$refs.qrCodeUrl, {
      text: url, // 需要转换为二维码的内容
      width: 200,
      height: 200,
      colorDark: '#000000',
      colorLight: '#ffffff'
    });
  }
  //关闭二维码弹框
  handleCancelCode() {
    this.codeVisible = false;
  }
  //
  showCodeImg() {
    if (!this.formData.payPlateCode) return;
    this.previewVisible = true;
    this.$nextTick(function() {
      let els = document.querySelector('#qrcodeimg');
      while (els.hasChildNodes()) {
        els.removeChild(els.firstChild);
      }
      //生成二维码
      this.creatQrCodeImg(this.formData.payPlateCode);
    });
  }
  //创建二维码
  creatQrCodeImg(url) {
    var qrcode = new QRCode(this.$refs.qrCodeImg, {
      text: url, // 需要转换为二维码的内容
      width: 600,
      height: 600,
      colorDark: '#000000',
      colorLight: '#ffffff'
    });
  }
  //
  handlePreviewCancel() {
    this.previewVisible = false;
  }

  parkDownloading = false;
  async download() {
    console.log(moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), '当前时间');
    if (this.parkDownloading) return;
    this.parkDownloading = true;
    try {
      const res = await downloadexport(
        {
          parkName: this.parkName,
          parkId: this.parkIds.join(','),
          // areaArr: this.areaArr,
          provinceId: this.areaArr[0],
          cityId: this.areaArr[1],
          areaId: this.areaArr[2],
          status: this.status.join(','),
          connectStatus: this.connectStatus.join(','),
          parkType: this.parkType,
          deviceProvider: this.deviceProvider
        },
        `车场信息 ${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`
      );
    } catch (e) {
      console.log(e);
    } finally {
      this.parkDownloading = false;
    }
  }

  /**
   * 表头筛选
   */
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }

  imgUrl: string = '';
  imgParkId: string = '';
  // 获取时代二维码
  async getQRCodeDetail(refresh: boolean = false) {
    this.imgUrl = '';
    this.formData.parkName = '';
    this.formData.parkCode = '';
    try {
      this.qrCodeLoading = true;
      const { status, msg, code, data } = await getParkQRCode({
        parkId: this.imgParkId,
        refresh: refresh
      });
      if (status === '9999') {
        this.formData.parkName = data.parkName;
        this.formData.parkCode = data.parkCode;
        this.imgUrl = `${API_SERVER.imgBaseUrl}${data.qrCodeFilePath}`;
      }
    } catch (error) {
      console.log(error);
      // this.$message.error((error && error.msg) || '系统繁忙，请稍后再试')
    } finally {
      this.qrCodeLoading = false;
    }
  }
  // 刷新
  refreshQrcode() {
    this.getQRCodeDetail(true);
  }
  // 下载图片
  downloadQrcode() {
    // var canvas = document.createElement('canvas')
    // var img = document.createElement('img')
    // img.onload = function(e) {
    //   canvas.width = img.width
    //   canvas.height = img.height
    //   var context = canvas.getContext('2d')
    //   context.drawImage(img, 0, 0, img.width, img.height)
    //   canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height)
    //   canvas.toBlob(blob => {
    //     let link = document.createElement('a')
    //     link.href = window.URL.createObjectURL(blob)
    //     link.download = '小程序码图片'
    //     link.click()
    //   }, 'image/jpeg')
    // }
    // img.setAttribute('crossOrigin', 'Anonymous')
    // img.src = 'https://parking-file-uat.oss-cn-shenzhen.aliyuncs.com/parkImage/20201201111248523019076005700357.png'
    let link = document.createElement('a');
    link.href = this.imgUrl;
    link.download = '小程序码图片';
    link.click();
  }
}
